'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _reactRedux = require('react-redux');

var _actions = require('../actions');

var _TaskFormView = require('../components/Tasks/TaskFormView.jsx');

var _TaskFormView2 = _interopRequireDefault(_TaskFormView);

var _client = require('../client');

var _client2 = _interopRequireDefault(_client);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var mapStateToProps = function mapStateToProps(state) {
  return state.currentTask;
};

var mapDispatchToProps = function mapDispatchToProps(dispatch, ownProps) {
  return {
    clearContent: function clearContent() {
      return dispatch((0, _actions.setContent)(null));
    },
    clearStyle: function clearStyle() {
      return dispatch((0, _actions.setStyle)(null));
    },
    setAlpha: function setAlpha(alpha) {
      return dispatch((0, _actions.setAlpha)(alpha));
    },
    createTask: function createTask() {
      return dispatch((0, _actions.createTask)(function (t) {
        console.log(_client2.default.task);
        _client2.default.task.show(t.id).then(function (task) {
          dispatch((0, _actions.addTask)(task));
        });
      }));
    }
  };
};

var TaskForm = (0, _reactRedux.connect)(mapStateToProps, mapDispatchToProps)(_TaskFormView2.default);

exports.default = TaskForm;


//////////////////
// WEBPACK FOOTER
// ./client/containers/taskForm.js
// module id = 109
// module chunks = 0